// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"4e350478","71":"4e350478","96":"4e350478","315":"a9e21cd7","392":"4e350478","509":"4e350478","583":"4e350478","649":"4e350478","716":"4e350478"}[chunkId] + ".chunk.css";
};